<template>
  <v-container fluid align-start ma-0 pa-2 class="epmsa050-main container-height">
    <v-row no-gutters class="h-full">
      <v-col cols="12">
        <i-card-vertical
          :headerTitle="menuTitle"
          class="h-full"
          :useBtnList="useBtnList"
          @btnRetrieve="btnRetrieve"
        >
          <template v-slot:body>
            <v-row no-gutters>
              <v-col>
                <i-card-top
                  class="d-md-flex"
                  outlined
                >
                  <template v-slot:body>
                    <v-row no-gutters class="center pa-2">
                      <i-label :label="'Ship No :'" />
                      <v-col cols="1">
                        <v-select
                          v-model="shipNo"
                          :items="shipNoList"
                          return-object
                          item-text="shipNo"
                          item-value="shipNo"
                          single-line
                          outlined
                          dense
                          label="Select"
                          @change="shipNoChange()"
                          height="32" />
                      </v-col>
                    </v-row>
                  </template>
                </i-card-top>
              </v-col>
            </v-row>

            <v-row no-gutters class="pt-1">
              <v-col cols="3">
                <DxDataGrid
                  class="listBox"
                  id="epmsa050"
                  :ref="epmsa050Ref"
                  :data-source="dataList" 
                  :remote-operations="false" 
                  :hover-state-enabled="true"
                  :allow-column-resizing="true" 
                  :allow-column-reordering="true"
                  :row-alternation-enabled="true" 
                  :show-borders="true" 
                  :width='grid.width'
                  :show-row-lines="true" 
                  key-expr="id" 
                  :focused-row-enabled="true"
                  :column-hiding-enabled="false" 
                  :sorting="{ mode: 'none' }"
                  :selection="{ mode: 'none' }"
                  @cellClick="cellClick"
                >
                  <DxPaging :enabled="false" />
                  <DxPager :visible="false" />
                  <DxColumn data-field="shipNo" caption="Ship" width="10%" alignment="center" :allow-editing="false" data-type="String"/>
                  <DxColumn data-field="block" caption="Block" width="10%" alignment="center" :allow-editing="false" data-type="String"/>
                  <DxColumn data-field="porNo" caption="POR No" width="15%" alignment="center" :allow-editing="false" data-type="String"/>
                  <DxColumn data-field="initTot" caption="E.Wgt" width="10%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />
                  <DxColumn data-field="initTot2" caption="F.Wgt" width="10%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />
                  <DxColumn data-field="finalPorChk" caption="Final Check" width="5%" alignment="center" :allow-editing="false" data-type="String"/>
                </DxDataGrid>
              </v-col>

              <v-col cols="9" class="pl-1">
                <v-row dense class="form-layout">
                  <v-col cols="14" class="pa-0">
                    <v-row no-gutters>
                      <v-col cols="14" class="pa-2 d-flex align-center formText">
                        <span class="pr-1">Block: </span>
                        <div class="v-text-field_block">
                          <v-text-field 
                            class="text-center"
                            v-model="block" 
                            dense 
                            outlined 
                            hide-details="auto"
                          />
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters class="pt-1" style="height: calc(100% - 36px);">
                  <v-col>
                    <DxDataGrid
                      id="epmsa051"
                      :ref="epmsa051Ref"
                      :data-source="dataList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="true"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      :selection="{ mode: 'none' }"
                      @cellPrepared="cellPrepared2"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />
                      <DxColumn data-field="gbn" caption="Division" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="spec" caption="Specification" width="15%" alignment="left" :allow-editing="false" />
                      <DxColumn caption="Estimte Weight" width="30%" alignment="center" :allow-editing="false">
                        <DxColumn data-field="matlUnit" caption="Unit" width="8%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="revNo" caption="Rev" width="8%" alignment="center" :allow-editing="false" />
                        <DxColumn data-field="initSa" caption="Supp.Wgt" width="8%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />
                        <DxColumn data-field="initDo" caption="Contr.Wgt" width="8%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />
                        <DxColumn data-field="initTot" caption="Total.Wgt" width="8%" alignment="right" :allow-editing="false" data-type="number" format="#,##0" />
                        <DxColumn data-field="initReqDt" caption="Date" width="8%" alignment="center" :allow-editing="false" />
                      </DxColumn>
                      <DxColumn caption="Final Weight" width="30%" alignment="center" :allow-editing="false">
                        <DxColumn data-field="matlUnit2" caption="Unit" width="8%" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="revNo2" caption="Rev" width="8%" alignment="center" :allow-editing="false"/>
                        <DxColumn data-field="initSa2" caption="Supp.Wgt" width="8%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="initDo2" caption="Contr.Wgt" width="8%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="initTot2" caption="Total.Wgt" width="8%" alignment="right" :allow-editing="false" data-type="number" format="#,##0"/>
                        <DxColumn data-field="initReqDt2" caption="Date" width="8%" alignment="center" :allow-editing="false"/>
                      </DxColumn>

                      <DxSummary>
                        <DxTotalItem column="gbn" summary-type="count" display-format="TOTAL" />
                        <DxTotalItem column="initSa" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="initDo" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="initTot" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="initSa2" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="initDo2" summary-type="sum" :customize-text="totalFormat" />
                        <DxTotalItem column="initTot2" summary-type="sum" :customize-text="totalFormat" />
                      </DxSummary>
                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import iButton from '@/components/common/iButton'
import notify from 'devextreme/ui/notify'
import { getDateFormat, getLastDate2, getNumComma, trim } from '@/utils/common.js'
import { getShipNoList1 } from '@/api/view/hip/common/common.js'
import { epmsa050, epmsa051} from '@/api/view/hip/A/epmsa050'

export default {
  name: 'epmsa050',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
    iButton
  },
  data() {
    return {
      menuTitle: this.$route.meta.title,
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      useBtnList: ['btnRetrieve'],
      epmsa050Ref: 'epmsa050Ref',
      epmsa051Ref: 'epmsa051Ref',
      dataList: [],
      dataList2: [],
      shipNo: '',
      block: '',
      shipNoList: [],
      mergeEls: {}
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.epmsa050Ref)
    },
    grid2Instance() {
      return this.GetDataGrid(this.epmsa051Ref)
    }
  },
  async mounted() {
     this.init()
     this.getShipNoList()
     this.btnRetrieve()
  },
  methods: {
    init() {
      this.gridInstance.option('defaultPaging', false)
      this.grid2Instance.option('defaultPaging', false)
    },
    clearGrid() {
      this.gridInstance.option('focusedRowIndex', -1)
      this.gridInstance.clearSelection()
      this.dataList = []
      this.block = ''
    },
    clearGrid2() {
      this.grid2Instance.clearSelection()
      this.dataList2 = []
      this.block = ''
    },
    async getShipNoList() {
      const param = {
        makerCd: this.makerCd
      }
      await getShipNoList1(param).then(res => {
          this.shipNoList.push('')
          res.list.forEach(e => {
            this.shipNoList.push(e.shipNo)
          });
          this.shipNo = this.shipNoList[0] ;
      })
    },
    async btnRetrieve(detail = true) {
      this.clearGrid()
      this.clearGrid2()

      const param = {   
        shipNo: this.shipNo
      }
      this.openLoading()
      await epmsa050(param).then(res => {
        let data = res.list
        let id = 0
        data.forEach(row => {
          id++
          row.id = id
        })

        this.dataList = data
        if(this.dataList.length > 0 && detail) {
          this.gridInstance.option('focusedRowIndex', 0)
          this.block = this.dataList[0].block
          this.shipNo = this.dataList[0].shipNo
          this.getDetail()
        }
      }).finally(() => {
        this.endLoading()
      })
    },
    async getDetail() {
      const param = {
        shipNo: this.shipNo,
        block: this.block
      }

      this.clearGrid2()

      this.openLoading()
      await epmsa051(param).then(res => {
        let data = res.list
        let id = 0
        data.forEach(row => {
          id++
          row.id = id
        })

        this.dataList2 = data
      }).finally(() => {
        this.endLoading()
      })
    },
    cellClick(e) {
      if(e.rowType === 'data') {
        if(e.rowIndex >= 0) {
          this.shipNo = e.data.shipNo
          this.block = e.data.block
          //console.log('cellClick Event: ' +  e.data.shipNo + "- " + e.data.block)
          this.getDetail()
        }
      }
    },
    // cellPrepared(e) {
    //   if (e.rowType == 'data') {
    //     if (e.rowIndex > 0 && e.column.command != 'edit') {
    //       if(e.column.dataField === 'invoiceNo') {
    //         if (e.component.cellValue(e.rowIndex - 1, e.column.dataField) == e.value) {
    //           if (e.component.cellValue(e.rowIndex - 1, e.column.dataField)) {
    //             var prev = this.mergeEls[e.rowIndex - 1][e.column.dataField]
    //             if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
    //             this.mergeEls[e.rowIndex][e.column.dataField] = prev
    //             if (prev) {
    //               e.cellElement.style.display = 'none'
    //               var span = prev.getAttribute('rowspan')
    //               if (span)
    //                 prev.setAttribute('rowspan', Number(span) + 1)
    //               else
    //                 prev.setAttribute('rowspan', 2)
    //             }
    //           }
    //           else
    //           {
    //             if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
    //             this.mergeEls[e.rowIndex][e.column.dataField] = e.cellElement
    //           }
    //         }
    //         else {
    //           if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
    //           this.mergeEls[e.rowIndex][e.column.dataField] = e.cellElement
    //         }
    //       }
    //     }
    //     else {
    //       if (!this.mergeEls[e.rowIndex]) this.mergeEls[e.rowIndex] = {}
    //       this.mergeEls[e.rowIndex][e.column.dataField] = e.cellElement
    //     }
    //   }
    // },
    cellPrepared2(e) {
      if(e.rowType === 'header') {
        if(e.column.caption === "Estimte Weight" || e.column.dataField ==="matlUnit" || e.column.dataField ==="revNo" || 
           e.column.dataField ==="initSa" || e.column.dataField ==="initDo" || e.column.dataField ==="initTot" || e.column.dataField ==="initReqDt") {
          e.cellElement.style.backgroundColor = "#D6D3F7"
        }
        if(e.column.caption === "Final Weight" || e.column.dataField ==="matlUnit2" || e.column.dataField ==="revNo2" || 
           e.column.dataField ==="initSa2" || e.column.dataField ==="initDo2" || e.column.dataField ==="initTot2" || e.column.dataField ==="initReqDt2") {
          e.cellElement.style.backgroundColor = "#D0A3F7"
        }
      }else if(e.rowType === 'totalFooter') {
        // console.log('cellPrepared2 Event', e)

        // if(c) {
        //   e.cellElement.setAttribute('colspan', 3)
        // } else if(e.column.dataField === 'block' || e.column.dataField === 'gbn' || e.column.dataField === 'spec' || e.column.dataField === 'porNo'){
        //   e.cellElement.style.display = 'none'
        // }
      }
    },
    shipNoChange(){
      this.btnRetrieve() 
    },
    totalFormat(e) {
      const result = getNumComma(Number(e.value), 2)
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.epmsa050-main {
  .form-layout::v-deep .col {
    border-width: 1px 0 0 1px;
    border-style: solid;
    border-color: gray;
    
    .row {
      border-width: 0 0 1px 0 !important;
      border-style: solid !important;
      border-color: gray !important;
    }

    .col {
      border-width: 0 1px 0 0 !important;
      border-style: solid !important;
      border-color: gray !important;
    }
  }

  .formHeader {
    background-color: rgb(223, 227, 213);
    font-weight: bold;
    // border: 1px solid gray;
    color: black;
    font-size: 9pt;
  }

  .formText, .invoice-amount-text {
    color: #000000;
  }

  .v-text-field_block {
    width: 135px;
  }

  .v-text-field__dely-no {
    width: 100px;
  }
  .v-text-field {
    width: 135px;
  }
  #epmsa051Ref {
    height: 100vh;
    max-height: calc(100vh - 234px);
  }
}
</style>
